import React, { memo, type SVGProps } from 'react';
import styled from 'styled-components';

interface PageHeaderProps {
  title?: string | React.ReactNode;
  onBack?: () => void;
  className?: string;
  align?: 'center' | 'left';
}

const iconProps: SVGProps<SVGSVGElement> = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "black",
  strokeWidth: "2.25",
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 50,
}

const ArrowLeft = memo(function ArrowLeft() {
  return (
    <svg {...iconProps}>
      <path d="m12 19-7-7 7-7" />
      <path d="M19 12H5" />
    </svg>
  )
})

const PageHeader = ({ title, onBack, className, align = 'center' }: PageHeaderProps) => {
  return (
    <HeaderContainer className={className}>
      {onBack && (
        <BackButton
          type="button"
          aria-label="Go back"
          onClick={onBack}
        >
          <ArrowLeft />
        </BackButton>
      )}
      {title && (
        <Title $align={align}>
          {title}
        </Title>
      )}
    </HeaderContainer>
  );
};

export default PageHeader;

const HeaderContainer = styled.header`
  position: relative;
  width: 100%;
  max-width: 1040px;
  margin: 0 auto;
  padding-top: calc(env(safe-area-inset-top, 0px) + 58px);
  box-sizing: border-box;
`;

const BackButton = styled.button`
  position: absolute;
  top: calc(env(safe-area-inset-top, 0px) + 10px);
  left: 0;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  background: transparent;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.15s cubic-bezier(0.175, 0.885, 0.32, 2.2);
  -webkit-tap-highlight-color: transparent;
  
  &:active {
    transform: scale(0.95);
  }

  &:focus-visible {
    outline: 2px solid rgba(0, 0, 0, 0.3);
    outline-offset: 2px;
  }
  
  img {
    width: 24px;
    height: 24px;
    display: block;
  }
`;

const Title = styled.h1<{ $align: 'center' | 'left' }>`
  margin: 0 0 8px 0;
  font-family: 'SLTFTheSilverEditorial', serif;
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.2;
  text-align: ${({ $align }) => $align};
  color: #000;
`;


